import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataData,
} from '../../../business-components/Date/Date'

import {
    ExportExcelRight
} from '../../../business-components/Excel/Excel'

import {
    formataListExcel
} from '../../../business-components/Excel/ExcelService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTitulo,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosPerc,
    formataTableCellBodyExibeDadosTotalTitulo,
    formataTableCellBodyExibeDadosTotalValor,
    formataTableCellBodyExibeDadosTotalPerc,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    tituloCliente,
} from '../cliente-form/ClienteService'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'

import {
    aumentoLetraGarantias,
    ajusteAumentoLetraGarantiasDescricao,
    //ajusteAumentoLetraGarantiasValor,
} from './EstudoServiceGarantias'



const EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios = ( { values, estudo, report, report1Pagina,
    indInicial, indFinal, popup } ) => {

    const PatrimonioImobilizadoDetalhado = () => {

        const { aumentoLetraCabecalho, aumentoLetraReportCabecalho, aumentoLetra, aumentoLetraReport,
            aumentoLetraTotal, aumentoLetraTotalReport } = aumentoLetraGarantias(values, true)

        let headList = [
            {
                colSpan: 20,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.descricao, report, false,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.uf, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 9,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMercadoQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorContabil, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 6,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.dataCompra, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorCompra, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tipoPlanejamentoSucessorio, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]

        return (
            <>
                {(report1Pagina || popup) && ( // mudança da fonte
                    <h6>
                        {LABEL.patrimonioImobilizadoNegocios.toUpperCase()}
                    </h6>
                )}

                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.patrimonioImobilizadoDetalhadoNegocios?.map((item, ind) => {
                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosTitulo(item.descricao, report, false, false,
                                                    aumentoLetra, aumentoLetraReport +
                                                        ajusteAumentoLetraGarantiasDescricao(values, item.descricao), values)
                                            :
                                                formataTableCellBodyExibeDadosTotalTitulo(item.descricao, report,
                                                    aumentoLetraTotal, aumentoLetraTotalReport, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados && (
                                            formataTableCellBodyExibeDadosTexto(item.ufItcmd, report,
                                                false, true, aumentoLetra, aumentoLetraReport, values)
                                        )}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosValor(item.valor, report, false, true,
                                                    aumentoLetra, aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTotalValor(item.valor, report, true,
                                                    aumentoLetraTotal, aumentoLetraTotalReport/* +
                                                        ajusteAumentoLetraGarantiasValor(values, item.valor)*/, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosPerc(item.valor /
                                                    estudo.current.ativos * 100, report,
                                                        false, true, aumentoLetra, aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTotalPerc(item.valor /
                                                    estudo.current.ativos * 100, report, true)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[4].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosValor(item.valorContabil, report, false, true,
                                                    aumentoLetra, aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTotalValor(item.valorContabil, report, true,
                                                    aumentoLetraTotal, aumentoLetraTotalReport/* +
                                                        ajusteAumentoLetraGarantiasValor(values, item.valorContabil)*/, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[5].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados && (
                                            formataTableCellBodyExibeDadosTexto(formataData(item.dataCompra), report, false, true,
                                                aumentoLetra, aumentoLetraReport, values)
                                        )}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[6].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados
                                            ?
                                                formataTableCellBodyExibeDadosValor(item.valorCompra, report, false, true,
                                                    aumentoLetra, aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTotalValor(item.valorCompra, report, true,
                                                    aumentoLetraTotal, aumentoLetraTotalReport/* +
                                                        ajusteAumentoLetraGarantiasValor(values, item.valorCompra)*/, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[7].colSpan}
                                    >
                                        {item.nivel === HARDCODE.reportNivelDados && (
                                            formataTableCellBodyExibeDadosTexto(item.descricaoTipoPlanejamentoSucessorio, report,
                                                false, true, aumentoLetra, aumentoLetraReport, values)
                                        )}
                                    </TableCellBodyExibeDados>
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>  
            </>
        )
    }

    return (
        report
            ?
                <GridContainer
                    //className='mt--2'
                >
                    <GridItem12>
                        <PatrimonioImobilizadoDetalhado/>
                    </GridItem12>
                </GridContainer>
            :
                <>
                    <ExportExcelRight
                        listExcel={formataListExcel(estudo.current.patrimonioImobilizadoDetalhadoNegocios,
                            ['descricao', 'ufItcmd', 'valor', 'valorContabil', 'dataCompra', 'valorCompra',
                                'descricaoTipoPlanejamentoSucessorio'])
                        }
                        nomeArquivoExcel={LABEL.patrimonioImobilizadoNegocios + ' ' + tituloCliente(values)}
                    />

                    <CardGridEstudoPadrao
                        label={LABEL.patrimonioImobilizadoNegocios}
                        component={<PatrimonioImobilizadoDetalhado/>}
                        overflowX={true}
                        popup={popup}
                    />
                </>
    )
}

export default EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios